'use client';

import { PublicEducator } from '@cademy-package/sdk-component-types';
import { FunctionComponent, PropsWithChildren, useState, useEffect } from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';
import Link from 'next/link';
import Image from 'next/image';
import { UserDropdown } from '../../MarketplaceShell/Header/UserDropdown';
import { AdminDashboardButton } from './AdminDashboardButton';

export type MinisiteShellHeaderProps = PropsWithChildren<{
    educator: PublicEducator;
}>;

export const MinisiteShellHeader: FunctionComponent<MinisiteShellHeaderProps> = ({ educator }) => {
    const [logoHref, setLogoHref] = useState('/');

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const parentWindowUrl = urlParams.get('parent_window_url');

        if (parentWindowUrl) {
            try {
                const decodedUrl = decodeURIComponent(parentWindowUrl);
                const url = new URL(decodedUrl, window.location.origin);
                setLogoHref(decodedUrl);
            } catch (error) {
                setLogoHref('/');
            }
        }
    }, []);

    return (
        <header className={classNames('container', styles.container)}>
            <Link className={styles.educatorLogoAndTitle} href={logoHref}>
                <div className={classNames('rounded_image', styles.logoContainer)}>
                    <Image
                        src={
                            educator.logo_url ||
                            `${process.env.NEXT_PUBLIC_ASSETS_URL}/images/educator_fallback_logo.svg`
                        }
                        alt={`${educator.name} logo`}
                        height={25}
                        width={50}
                        sizes="55px, 110px"
                        style={{
                            maxWidth: '100%',
                            height: 'auto',
                        }}
                    />
                </div>
                <h2>{educator.name}</h2>
            </Link>

            <nav>
                <AdminDashboardButton className={styles.adminDashboardButton} />
                <UserDropdown educatorId={educator._id} />
            </nav>
        </header>
    );
};
